import { BpLineModel } from './../../../../shared/models/societe-linked/bp/bp-line.model';
import { DetailBpLineinfos } from './../../bp-components.service';
import { BpModel } from '../../../../shared/models/societe-linked/bp/bp.model';
import { SocieteModel } from '../../../../shared/models/simple-types/societe.model';
import { UntypedFormGroup, UntypedFormArray, AbstractControl, UntypedFormControl } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, SimpleChanges, ViewChild, OnChanges} from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

@Component({
  selector: 'app-bp-line-facturation-array',
  templateUrl: './bp-line-facturation-array.component.html',
  styleUrls: ['./bp-line-facturation-array.component.scss']
})
export class BpLineFacturationArrayComponent implements OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  @Input() bcLineForm: UntypedFormGroup;
  @Input() detailInfos: DetailBpLineinfos;
  bcLine: UntypedFormGroup;
  society: SocieteModel;
  bpLineFormArray: UntypedFormArray;
  showDelay = new UntypedFormControl(0);
  hideDelay = new UntypedFormControl(0);
  bpLineList: BpLineModel[];
  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4'];
  displayedColumnsBP: string[] = ['annule', 'code', 'position', 'libelle', 'qteBC', 'qteRestant', 'qteLivre', 'qteBP', 'puBC', 'puBP', 'htBC', 'htRestant', 'htBP', 'tva', 'naCode', 'cg', 'ca1', 'ca2', 'complement', 'equipement', 'codeAe', 'ttc'];
  matDataSourceBPLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  selection = new SelectionModel<BpLineModel>(true, []);
  bp: BpModel;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void{
    if (this.form) {
      this.bpLineFormArray = this.form.controls['bpLines'] as UntypedFormArray;
      this.reload();
    }
  }

  reload(): void {
    if (this.bpLineFormArray) {
      this.matDataSourceBPLigne = new MatTableDataSource<AbstractControl>(this.bpLineFormArray.controls);
      setTimeout(() => this.matDataSourceBPLigne.paginator = this.paginator, 100);
    }
  }

}

